import React, { useState, useEffect, useCallback } from 'react';
import Layout from '../components/Layout';
import ImportarClientes from '../components/ImportarClientes';
import ClienteFormModal from '../components/clientes/ClienteFormModal';
import ProrrateoModal from '../components/clientes/ProrrateoModal';
import DetalleClienteModal from '../components/clientes/DetalleClienteModal';
import RedDelCliente from '../components/clientes/RedDelCliente';
import { estadoColor, estadoBg, formatCOP, formVacio } from '../components/clientes/clientesHelpers';
import { s } from '../components/clientes/clientesEstilos';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import { exportarClientesPDF, exportarClientesExcel } from '../services/exportar';
import { useEmpresa } from '../context/EmpresaContext';

export default function Clientes() {
  const { usuario } = useAuth();
  const [clientes, setClientes] = useState([]);
  const [planes, setPlanes] = useState([]);
  const [proveedoresRed, setProveedoresRed] = useState([]);
  const [perfilesPPPoE, setPerfilesPPPoE] = useState([]);
  const [ipsDisponibles, setIpsDisponibles] = useState([]);
  const [cargandoIPs, setCargandoIPs] = useState(false);
  const [modalDetalle, setModalDetalle] = useState(false);
  const [clienteDetalle, setClienteDetalle] = useState(null);
  const [fotos, setFotos] = useState([]);
  const [fotoActiva, setFotoActiva] = useState(null);
  const [buscar, setBuscar] = useState('');
  // Arranca en los que SI tienen servicio: los retirados y los inactivos temporales
  // llenaban la lista del dia a dia sin que hubiera nada que hacer con ellos. Siguen a un
  // clic, en el filtro.
  /**
   * Arranca en los que SI tienen servicio: los retirados y los inactivos temporales
   * llenaban la lista del dia a dia sin que hubiera nada que hacer con ellos. Siguen a un
   * clic, en el filtro.
   *
   * Salvo que se llegue desde el panel con un filtro puesto —«ver cuales» en una de sus
   * tarjetas—: ahi ya se dijo que se venia a buscar, y cambiarlo seria perder el viaje.
   */
  const [filtroEstado, setFiltroEstado] = useState(
    () => new URLSearchParams(window.location.search).get('filtro') || 'con_servicio');
  const [modal, setModal] = useState(false);
  const [modalProrrateo, setModalProrrateo] = useState(false);
  const [modalImportar, setModalImportar] = useState(false);
  const [clienteProrrateo, setClienteProrrateo] = useState(null);
  const [resultProrrateo, setResultProrrateo] = useState(null);
  const [calculando, setCalculando] = useState(false);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState(formVacio);
  const [capturandoGPS, setCapturandoGPS] = useState(false);
  const [precisionGPS, setPrecisionGPS] = useState(null);
  const [error, setError] = useState('');
  const [guardando, setGuardando] = useState(false);
  // Lo que paso en el MikroTik al guardar. Se muestra hasta que se cierre: si
  // desapareciera solo, el aviso de que un cliente quedo sin servicio se perderia.
  const [aviso, setAviso] = useState(null);
  const { empresa } = useEmpresa();
  const [stats, setStats] = useState({});

  const cargar = useCallback(async () => {
    const params = new URLSearchParams();
    if (buscar) params.append('buscar', buscar);
    if (filtroEstado) params.append('estado', filtroEstado);
    const [resClientes, resStats] = await Promise.all([
      api.get(`/api/clientes?${params}`),
      api.get('/api/clientes/stats/resumen'),
    ]);
    setClientes(resClientes.data);
    setStats(resStats.data);
  }, [buscar, filtroEstado]);

  useEffect(() => { cargar(); }, [cargar]);
  useEffect(() => {
    api.get('/api/planes').then(r => setPlanes(r.data));
    api.get('/api/proveedores-red').then(r => setProveedoresRed(r.data)).catch(() => {});
    api.get('/api/mikrotik/perfiles-pppoe').then(r => setPerfilesPPPoE(r.data)).catch(() => {});
  }, []);

  const limpiarClientes = async () => {
    if (!window.confirm('⚠️ ¿Eliminar TODOS los clientes y sus datos relacionados?\n\nEsta acción es IRREVERSIBLE.')) return;
    if (!window.confirm('¿Estás seguro? Se eliminarán todos los clientes, pagos, tickets y datos relacionados.')) return;
    try {
      await api.delete('/api/clientes/limpiar-todo');
      alert('Base de datos de clientes limpiada correctamente.');
      cargar();
    } catch(e) { alert(e.response?.data?.error || 'Error al limpiar'); }
  };

  const abrirNuevo = async () => {
    setEditando(null);
    const revs = await api.get('/api/revendedores').catch(()=>({data:[]}));
    setForm({...formVacio, _origen: 'propia', _revendedores: revs.data});
    setError(''); setModal(true);
  };
  const abrirEditar = async (c) => {
    setEditando(c);
    const revs = await api.get('/api/revendedores').catch(()=>({data:[]}));
    setForm({ nombre: c.nombre, cedula: c.cedula || '', telefono: c.telefono || '', email: c.email || '', direccion: c.direccion || '', plan_id: c.plan_id || '', dia_pago: c.dia_pago || '1', notas: c.notas || '', estado: c.estado, fecha_instalacion: c.fecha_instalacion ? c.fecha_instalacion.split('T')[0] : '', observaciones_instalacion: c.observaciones_instalacion || '', tipo_cliente: c.tipo_cliente || 'residencial', contraprestacion: c.contraprestacion === true, motivo_contraprestacion: c.motivo_contraprestacion || '', tecnologia_instalada: c.tecnologia_instalada || '', precio_especial: c.precio_especial || '', motivo_precio_especial: c.motivo_precio_especial || '', proveedor_red_id: c.proveedor_red_id || '', mikrotik_tipo: c.mikrotik_tipo || 'ninguno', mikrotik_usuario: c.mikrotik_usuario || '', mikrotik_perfil: c.mikrotik_perfil || '', revendedor_id: c.revendedor_id || '', latitud: c.latitud || '', longitud: c.longitud || '', direccion_maps: c.direccion_maps || '', ubicacion_origen: c.ubicacion_origen || '', ip_cliente: c.ip_asignada || '', velocidad_contratada: c.velocidad_contratada || '', proveedor_pppoe_usuario: c.proveedor_pppoe_usuario || '', proveedor_pppoe_password: c.proveedor_pppoe_password || '', proveedor_vlan: c.proveedor_vlan || '', _origen: c.revendedor_id ? 'revendedor' : (c.proveedor_red_id ? 'proveedor' : 'propia'), _revendedores: revs.data });
    setError('');
    setModal(true);
  };

  const guardar = async () => {
    if (!form.nombre) { setError('El nombre es requerido'); return; }
    setGuardando(true);
    try {
      const { data } = editando
        ? await api.put(`/api/clientes/${editando.id}`, form)
        : await api.post('/api/clientes', form);

      /**
       * Las fotos que se eligieron ANTES de que el cliente existiera.
       *
       * Al crear no hay a quién colgárselas, así que el formulario las guarda en memoria y
       * se suben aquí, en cuanto hay id. Si alguna falla se avisa, pero el cliente ya
       * quedó creado: no se pierde el alta por una foto.
       */
      const pendientes = form._fotosPendientes || [];
      const nuevoId = data?.cliente?.id || data?.id;
      if (pendientes.length && nuevoId) {
        let fallaron = 0;
        for (const foto of pendientes) {
          try { await api.post(`/api/fotos/${nuevoId}/fotos`, foto); } catch (_) { fallaron++; }
        }
        if (fallaron) {
          setAviso({ tipo: 'ojo', texto: `El cliente quedó creado, pero ${fallaron} de las `
            + `${pendientes.length} fotos no se pudieron subir. Ábrelo y vuelve a intentarlo.` });
        }
      }

      setModal(false);
      cargar();
      /**
       * Decir qué pasó con el MikroTik, no solo que se guardó el cliente.
       *
       * Antes la pantalla decía «guardado» pasara lo que pasara en el router. Un cliente
       * podía quedar dado de alta y sin servicio —porque faltaba la contraseña, o porque
       * el MikroTik no contestó— y nadie se enteraba hasta que el cliente llamaba.
       */
      const mk = data?.mikrotik;
      if (mk && mk.mensaje && mk.hecho !== 'actualizado') {
        if (mk.hecho === 'creado') setAviso({ tipo: 'ok', texto: mk.mensaje });
        else setAviso({ tipo: 'ojo', texto: mk.mensaje });
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Error al guardar');
    } finally {
      setGuardando(false);
    }
  };

  const eliminar = async (c) => {
    if (!window.confirm(`¿Eliminar a "${c.nombre}"? Esta acción no se puede deshacer.`)) return;
    try { await api.delete(`/api/clientes/${c.id}`); cargar(); }
    catch (err) { alert(err.response?.data?.error || 'Error al eliminar'); }
  };

  const abrirProrrateo = async (c) => {
    // Recargar datos frescos del cliente desde la API
    try {
      const { data } = await api.get(`/api/clientes/${c.id}`);
      setClienteProrrateo(data);
    } catch {
      setClienteProrrateo(c);
    }
    setResultProrrateo(null);
    setModalProrrateo(true);
  };

  const calcularProrrateo = async () => {
    if (!clienteProrrateo.fecha_instalacion) {
      alert('El cliente no tiene fecha de instalación registrada. Edítalo primero.');
      return;
    }
    setCalculando(true);
    try {
      const hoy = new Date();
      const { data } = await api.post('/api/cartera/prorrateo', {
        cliente_id: clienteProrrateo.id,
        fecha_instalacion: clienteProrrateo.fecha_instalacion,
        mes: hoy.getMonth() + 1,
        anio: hoy.getFullYear(),
      });
      setResultProrrateo(data);
    } catch (err) {
      alert(err.response?.data?.error || 'Error al calcular prorrateo');
    } finally { setCalculando(false); }
  };

  const f = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const cargarIPs = async (tipo) => {
    if (tipo === 'ninguno') { setIpsDisponibles([]); return; }
    setCargandoIPs(true);
    try {
      const red = tipo === 'pppoe' ? 'pppoe' : 'radio';
      const { data } = await api.get(`/api/mikrotik/ips-disponibles?red=${red}`);
      setIpsDisponibles(data.disponibles || []);
    } catch (e) { setIpsDisponibles([]); }
    finally { setCargandoIPs(false); }
  };

  const accionMikrotik = async (c, accion) => {
    const textos = { suspender:'suspender', activar:'activar', inactivar:'marcar como INACTIVO TEMPORAL (baja a 64k)', reactivar:'REACTIVAR (restaura velocidad)' };
    const texto = textos[accion] || accion;
    if (!window.confirm(`¿${texto.charAt(0).toUpperCase() + texto.slice(1)} el servicio de ${c.nombre}?`)) return;
    try {
      await api.post(`/api/mikrotik/accion/${c.id}`, { accion });
      cargar();
    } catch (err) {
      alert(err.response?.data?.error || `Error al ${texto} cliente`);
    }
  };

  const obtenerUbicacion = () => {
    if (!navigator.geolocation) { alert('Tu navegador no soporta geolocalización.'); return; }
    if (window.isSecureContext === false) {
      alert('La ubicación solo funciona en conexiones seguras (https). Abre el sistema con https://');
      return;
    }
    setCapturandoGPS(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        // La columna guarda 7 decimales; capturar más solo se redondea (≈1 cm de precisión)
        f('latitud',  pos.coords.latitude.toFixed(7));
        f('longitud', pos.coords.longitude.toFixed(7));
        // Medida en el sitio: se distingue de la que se señala en el mapa desde el PC
        f('ubicacion_origen', 'gps');
        setPrecisionGPS(Math.round(pos.coords.accuracy));
        setCapturandoGPS(false);
      },
      (err) => {
        setCapturandoGPS(false);
        const motivos = {
          1: 'Permiso denegado. Toca el candado 🔒 junto a la dirección web y permite la Ubicación; luego intenta de nuevo.',
          2: 'No se pudo determinar la ubicación. Revisa que el GPS del equipo esté encendido.',
          3: 'La ubicación tardó demasiado. Intenta de nuevo, preferiblemente al aire libre.',
        };
        alert(motivos[err.code] || ('No se pudo obtener la ubicación: ' + err.message));
      },
      // Sin estas opciones el navegador puede quedarse esperando sin avisar nunca
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
    );
  };

  const verDetalle = async (c) => {
    setClienteDetalle(c);
    setFotoActiva(null);
    try {
      const { data } = await api.get(`/api/fotos/${c.id}/fotos`);
      setFotos(data);
    } catch (e) { setFotos([]); }
    setModalDetalle(true);
  };

  const verFotoCompleta = async (foto) => {
    const { data } = await api.get(`/api/fotos/fotos/${foto.id}`);
    setFotoActiva(data);
  };

  return (
    <Layout>
      {/* Qué pasó en el MikroTik al guardar. No se cierra solo: si un cliente quedó dado
          de alta y sin servicio, ese aviso no puede desaparecer sin que nadie lo lea. */}
      {aviso && (
        <div onClick={() => setAviso(null)}
          style={{ margin: '0 0 14px', padding: '12px 15px', borderRadius: '10px',
            cursor: 'pointer', fontSize: '13px', lineHeight: '1.55',
            background: aviso.tipo === 'ok' ? 'rgba(16,185,129,0.1)' : 'rgba(251,191,36,0.1)',
            border: `1px solid ${aviso.tipo === 'ok' ? 'rgba(16,185,129,0.35)' : 'rgba(251,191,36,0.35)'}`,
            color: aviso.tipo === 'ok' ? '#6EE7B7' : '#FDE047' }}>
          {aviso.tipo === 'ok' ? '✓ ' : '⚠ '}{aviso.texto}
          <span style={{ opacity: 0.5, marginLeft: '8px', fontSize: '11.5px' }}>
            (clic para cerrar)
          </span>
        </div>
      )}

      {/* Header */}
      <div style={s.header}>
        <div>
          <h1 style={s.titulo}>Clientes</h1>
          <p style={s.sub}>Gestión de clientes y suscripciones</p>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
          <button style={s.btnExport} onClick={() => exportarClientesExcel(clientes)}>⬇ Excel</button>
          <button style={s.btnExport} onClick={() => exportarClientesPDF(clientes, empresa)}>🖨 PDF</button>
          <button style={s.btnImportar} onClick={() => setModalImportar(true)}>📂 Importar Excel</button>
          {usuario?.rol === 'superadmin' && (
            <button style={{...s.btnPrimario, background:'rgba(239,68,68,0.15)', border:'1px solid rgba(239,68,68,0.3)', color:'#FCA5A5'}} onClick={limpiarClientes}>
              🗑️ Limpiar BD
            </button>
          )}
          <button style={s.btnPrimario} onClick={abrirNuevo}>+ Nuevo Cliente</button>
        </div>
      </div>

      {/* Stats */}
      <div style={s.statsRow}>
        {[
          { label: 'Activos', val: stats.activos || 0, color: '#10B981' },
          { label: 'Morosos', val: stats.morosos || 0, color: '#F59E0B' },
          { label: 'Suspendidos', val: stats.suspendidos || 0, color: '#6366F1' },
          { label: 'Total', val: stats.total || 0, color: '#00E5FF' },
        ].map(st => (
          <div key={st.label} style={s.statCard}>
            <div style={{ ...s.statVal, color: st.color }}>{st.val}</div>
            <div style={s.statLabel}>{st.label}</div>
          </div>
        ))}
      </div>

      {/* Filtros */}
      <div style={s.filtros}>
        <input
          style={s.buscador}
          placeholder="🔍  Buscar por nombre, cédula o teléfono..."
          value={buscar}
          onChange={e => setBuscar(e.target.value)}
        />
        <select style={s.select} value={filtroEstado} onChange={e => setFiltroEstado(e.target.value)}>
          <option value="con_servicio">Con servicio (sin retirados ni inactivos)</option>
          <option value="no_se_cobra">🎁 Solo a los que no se les cobra</option>
          <option value="sin_conexion">⚠️ Sin conexión anotada (no se les puede seguir el rastro)</option>
          <option value="">Todos, incluidos retirados e inactivos</option>
          <option value="activo">Activo</option>
          <option value="moroso">Moroso</option>
          <option value="suspendido">Suspendido</option>
          <option value="inactivo_temporal">Inactivo temporal</option>
          <option value="retirado">Retirado</option>
        </select>
      </div>

      {/* Tabla */}
      <div style={s.tabla}>
        <table style={s.table}>
          <thead>
            <tr style={s.thead}>
              <th style={s.th}>Cliente</th>
              <th style={s.th}>Contacto</th>
              <th style={s.th}>Plan</th>
              <th style={s.th}>Red</th>
              <th style={s.th}>Día de pago</th>
              <th style={s.th}>Estado</th>
              <th style={s.th}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {clientes.length === 0 ? (
              <tr><td colSpan={7} style={s.vacio}>No hay clientes registrados</td></tr>
            ) : clientes.map(c => (
              <tr key={c.id} style={s.tr}>
                <td style={s.td}>
                  <div style={s.clienteNombre}>{c.nombre}</div>
                  {c.codigo && <div style={{fontSize:'11px',fontWeight:'700',color:'#00D4FF',fontFamily:'monospace'}}>{c.codigo}</div>}
                  {c.cedula && <div style={s.clienteSub}>CC {c.cedula}</div>}
                </td>
                <td style={s.td}>
                  {c.telefono && <div style={s.clienteSub}>📞 {c.telefono}</div>}
                  {c.email && <div style={s.clienteSub}>✉ {c.email}</div>}
                </td>
                <td style={s.td}>
                  {c.plan_nombre
                    ? <><div style={s.planNombre}>{c.plan_nombre}</div><div style={s.clienteSub}>{formatCOP(c.precio_especial || c.precio_mensual)}/mes</div></>
                    : <span style={s.sinPlan}>Sin plan</span>}
                  {/* A este no se le cobra: es de los que llevan «CR» en el MikroTik —el
                      dueño del lote de la torre y demás acuerdos—. Va donde el precio
                      porque es justo ahi donde engaña: se leia el valor del plan y parecia
                      que estaba facturando. */}
                  {c.contraprestacion && (
                    <div style={{ fontSize:'11px', color:'#6EE7B7', marginTop:'2px' }}
                      title={c.motivo_contraprestacion || 'No se le cobra'}>
                      🎁 No se le cobra
                    </div>
                  )}
                  {c.proveedor_red_nombre && <div style={{ fontSize:'11px', color:'#F59E0B', marginTop:'2px' }}>🌐 {c.proveedor_red_nombre}</div>}
                </td>
                {/* La tecnología ya no se escribe a mano aquí: sale del equipo que el
                    router encontró, junto con la IP y la caja de la que cuelga. */}
                <td style={s.td}><RedDelCliente cliente={c} compacto /></td>
                <td style={s.td}><span style={s.diaPago}>Día {c.dia_pago}</span></td>
                <td style={s.td}>
                  <span style={{ ...s.estadoBadge, color: estadoColor[c.estado], background: estadoBg[c.estado] }}>
                    {c.estado}
                  </span>
                </td>
                <td style={s.td}>
                  <div style={s.acciones}>
                    <button style={s.btnEdit} onClick={() => abrirEditar(c)}>Editar</button>
                    <button style={{ ...s.btnEdit, background:'rgba(0,229,255,0.1)', color:'#00E5FF' }} onClick={() => verDetalle(c)}>📄 Detalle</button>
                    <button style={s.btnProrrateo} onClick={() => abrirProrrateo(c)} title="Calcular cobro primer mes prorateado">⅟ Prorrateo</button>
                    {c.mikrotik_usuario && c.mikrotik_tipo !== 'ninguno' && (
                      (c.estado === 'suspendido' || c.estado === 'moroso')
                        ? ['admin','superadmin'].includes(usuario?.rol) && <button style={s.btnActivar} onClick={() => accionMikrotik(c, 'activar')}>▶ Activar</button>
                        : <button style={s.btnSuspender} onClick={() => accionMikrotik(c, 'suspender')}>⏸ Suspender</button>
                    )}
                    {c.estado !== 'inactivo_temporal' && c.estado !== 'retirado'
                      ? <button style={{ background:'rgba(168,85,247,0.1)', border:'none', borderRadius:'6px', padding:'5px 10px', color:'#C084FC', fontSize:'11px', cursor:'pointer', fontWeight:'600' }}
                          onClick={() => accionMikrotik(c, 'inactivar')}>
                          ⏸ Inactivo
                        </button>
                      : c.estado === 'inactivo_temporal' &&
                        <button style={{ background:'rgba(16,185,129,0.1)', border:'none', borderRadius:'6px', padding:'5px 10px', color:'#6EE7B7', fontSize:'11px', cursor:'pointer', fontWeight:'600' }}
                          onClick={() => accionMikrotik(c, 'reactivar')}>
                          ▶ Reactivar
                        </button>
                    }
                    <button style={s.btnDel} onClick={() => eliminar(c)}>Eliminar</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <ClienteFormModal
        abierto={modal}
        onCerrar={() => setModal(false)}
        editando={editando}
        form={form}
        f={f}
        error={error}
        guardando={guardando}
        guardar={guardar}
        planes={planes}
        proveedoresRed={proveedoresRed}
        perfilesPPPoE={perfilesPPPoE}
        ipsDisponibles={ipsDisponibles}
        cargandoIPs={cargandoIPs}
        cargarIPs={cargarIPs}
        obtenerUbicacion={obtenerUbicacion}
        capturandoGPS={capturandoGPS}
        precisionGPS={precisionGPS}
      />
      <ImportarClientes
        abierto={modalImportar}
        onCerrar={() => setModalImportar(false)}
        onImportado={() => { cargar(); setModalImportar(false); }}
      />

      <ProrrateoModal
        abierto={modalProrrateo}
        onCerrar={() => setModalProrrateo(false)}
        clienteProrrateo={clienteProrrateo}
        resultProrrateo={resultProrrateo}
        calculando={calculando}
        calcularProrrateo={calcularProrrateo}
      />

      <DetalleClienteModal
        abierto={modalDetalle}
        onCerrar={() => { setModalDetalle(false); setFotoActiva(null); }}
        clienteDetalle={clienteDetalle}
        fotos={fotos}
        fotoActiva={fotoActiva}
        verFotoCompleta={verFotoCompleta}
        cerrarFotoActiva={() => setFotoActiva(null)}
      />
    </Layout>
  );
}
